export const FOOTER_DESKTOP_HEIGHT = 35;
export const FOOTER_MOBILE_HEIGHT = 50;
export const HEADER_HEIGHT = 66;